// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  browserStreaming: false,

  cognito: {
    userPoolId: "eu-central-1_kCN5Vqb09",
    userPoolWebClientId: "67s3etl2f19bu49mmv63j05a2o",
    authenticationFlowType: "USER_PASSWORD_AUTH",
  },
  backend: {
    apiBaseUrl: "https://api-dev.clouddeck.app",
  },
  streaming: {
    domain: "cldk.me",
  },
  general: {
    appName: "CloudDeck",
    termsUrl: "https://clouddeck.app/terms",
    privacyPolicyUrl: "https://clouddeck.app/privacy",
    cookiePolicyUrl: "https://clouddeck.app/cookies",
    contactUrl: "https://clouddeck.app/contact",
    statusPageUrl: "https://status.clouddeck.app",
    copyrightHolderName: "CloudDeck",
  },
  ipstack: {
    accessKey: "f32bf907e695b15219428ecdd0b62659",
  },
  priceIds: {
    launch1m: "price_1Oo3iJEHcn0wjauz9yzMbkvH",
    launch6m: "price_1Sp9F3EHcn0wjauzzKbDoe7i",
    storageUpgrade1m: "price_1QWzshEHcn0wjauzNtGDMJNO",
    storageUpgrade6m: "price_1Sp9H7EHcn0wjauzpxCdtzGZ",
  },
  stripe: {
    publishableKey:
      "pk_test_51OZvScEHcn0wjauzmRfjATCVBOVC3vSzmmLt30L4Hlst2iRtd3FcZ9MmW8e94kCUUUz5KbJ2tGXoBlM92KlIT4Lo006hSkcwMx",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
